<template>
	<ValidationProvider v-slot="{ errors }" mode="eager" tag="div" :rules="rules">
		<div class="input-wrapper">
			<input
				v-model="inputValue"
				class="input input--floating-label"
				:class="{ 'input--icon': type === 'password', 'input--error': errors[0] || hasError }"
				:name="name"
				:type="localType"
				:placeholder="label"
				:required="required || null"
			/>
			<label class="floating-label">{{ label }}</label>
			<SvgIcon
				v-if="type === 'password'"
				class="input-icon"
				:icon-name="passwordHidden ? 'visibility' : 'visibility-off'"
				@click.native="togglePassword"
			/>
		</div>
		<Error v-if="errors[0]" class="mt-0.5" :data-test-id="'input-error-' + name">
			{{ errors[0] }}
		</Error>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon";
import Error from "./Error";

export default {
	components: {
		ValidationProvider,
		SvgIcon,
		Error,
	},
	props: {
		value: String,
		rules: String,
		hasError: Boolean,
		name: { type: String, required: true },
		type: { type: String, default: "text" },
		label: { type: String },
		required: { type: Boolean, default: false },
	},
	data() {
		return {
			passwordHidden: true,
			localType: this.type,
		};
	},
	computed: {
		inputValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
	},
	methods: {
		togglePassword() {
			this.passwordHidden = !this.passwordHidden;
			if (this.passwordHidden) {
				this.localType = "password";
			} else {
				this.localType = "text";
			}
		},
	},
};
</script>

<style lang="scss" scoped>
/* has to be redefined here because login layer uses a different font size than login component */
.input {
	border: unset;
	border-bottom: 1px solid $color-black;
	padding: 0 6px;
}

.input--error {
	border-color: $color-error;
}

.input--icon {
	padding-right: 36px;
}

.floating-label {
	left: unset;
	top: 10px;
	padding: 0 6px;
	color: $color-gray-dark;
}

.input--floating-label:focus + .floating-label,
.input--floating-label:not(:placeholder-shown) + .floating-label {
	transform: translate(2px, -18px) scale(0.8);
	color: $color-gray-dark;
}
</style>
